/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */

import React from "react";

export default function CommonRequest() {
  return (
    <div>
      <h2 className="helpHeaderTitle">Common Requests </h2>
      <div className="helpContentSection">
        <div className="questionAnsWrapper">
          <div className="questionRow boldTitle">
            <p className="questionSection">1.</p>
            <p className="answerSection">Send Preview Link for a Campaign </p>
          </div>
          <div className="questionRow ">
            <p className="questionSection" />
            <p className="answerSection">
              <ul>
                <li className="questionRow ml-0 mr-0">
                  <p className="questionSection">a.</p>{" "}
                  <p className="answerSection">
                    In the Campaign tab click on the Eyes to the right side of
                    the individual campaign
                  </p>
                </li>
                <li className="questionRow ml-0 mr-0">
                  <p className="questionSection">b.</p>{" "}
                  <p className="answerSection">
                    Click “Get Preview Link” and copy the URL to send to the
                    requestor.{" "}
                  </p>
                </li>
                <div>
                  <img
                    alt=""
                    src={require("../../assets/images/helpCenter/commonRequestImg1.png")}
                  />
                </div>
              </ul>
            </p>
          </div>
        </div>
        <div className="questionAnsWrapper">
          <div className="questionRow boldTitle">
            <p className="questionSection">2.</p>
            <p className="answerSection">
              Turn screens on for on-site tech / testing of support issue
            </p>
          </div>
          <div className="questionRow ">
            <p className="questionSection" />
            <p className="answerSection">
              <ul>
                <li className="questionRow ml-0 mr-0">
                  <p className="questionSection">a.</p>{" "}
                  <p className="answerSection">
                    Select either the “Logo Loop Landscape” or “Logo Loop
                    Portrait” campaign or the most recent homestand campaign for
                    that club
                  </p>
                </li>
                <li className="questionRow ml-0 mr-0">
                  <p className="questionSection">b.</p>{" "}
                  <p className="answerSection">
                    Push to the needed devices for the on-site work / diagnosis.
                  </p>
                </li>
              </ul>
            </p>
          </div>
        </div>
        <div className="questionAnsWrapper">
          <div className="questionRow boldTitle">
            <p className="questionSection">3.</p>
            <p className="answerSection">
              Turn screens on for an unscheduled off-event{" "}
            </p>
          </div>
          <div className="questionRow ">
            <p className="questionSection" />
            <p className="answerSection">
              <ul>
                <li className="questionRow ml-0 mr-0">
                  <p className="questionSection">a.</p>{" "}
                  <p className="answerSection">
                    If the client just wants to push the standard loop, you can
                    push the most recent homestand campaign to the appropriate
                    devices (considering landscape or portrait form factor).
                  </p>
                </li>
                <li className="questionRow ml-0 mr-0">
                  <p className="questionSection">b.</p>{" "}
                  <p className="answerSection">
                    If the client wishes to have custom content, open a ticket
                    and include the content team.
                  </p>
                </li>
              </ul>
            </p>
          </div>
        </div>
        <div className="questionAnsWrapper">
          <div className="questionRow boldTitle">
            <p className="questionSection">4.</p>
            <p className="answerSection">
              Download to USB where there are issues with connectivity
            </p>
          </div>
          <div className="questionRow ">
            <p className="questionSection" />
            <p className="answerSection">
              <ul>
                <li className="questionRow ml-0 mr-0">
                  <p className="questionSection">a.</p>{" "}
                  <p className="answerSection">
                    In Campaign tab, view the specific campaign you want pushed
                    to a device
                  </p>
                </li>
                <li className="questionRow ml-0 mr-0">
                  <p className="questionSection">b.</p>{" "}
                  <p className="answerSection">
                    In the top right click Download for USB
                  </p>
                </li>
                <img
                  alt=""
                  src={require("../../assets/images/helpCenter/commonRequestImg2.png")}
                />
                <li className="questionRow ml-0 mr-0">
                  <p className="questionSection">c.</p>{" "}
                  <p className="answerSection">
                    Plug in USB stick into your computer
                  </p>
                </li>
                <li className="questionRow ml-0 mr-0">
                  <p className="questionSection">d.</p>{" "}
                  <p className="answerSection">
                    Extract the contents of the zip file into the USB stick.
                    There should be a folder called campaign and file called
                    script.sh{" "}
                  </p>
                </li>
                <li className="questionRow ml-0 mr-0">
                  <p className="questionSection">e.</p>{" "}
                  <p className="answerSection">
                    Plug USB stick into unit. The campaign should auto start
                    playing after a few moments.{" "}
                  </p>
                </li>
              </ul>{" "}
            </p>
          </div>
        </div>
        <div className="questionAnsWrapper">
          <div className="questionRow boldTitle">
            <p className="questionSection">5:</p>
            <p className="answerSection">
              Check screenshots to view content playing{" "}
            </p>
          </div>
          <div className="questionRow ">
            <p className="questionSection" />
            <p className="answerSection">
              <ul>
                <li className="questionRow ml-0 mr-0">
                  <p className="questionSection">a.</p>{" "}
                  <p className="answerSection">
                    In the network tab click on the name of the desired screen
                    to view its screen information.
                  </p>
                </li>
                <li className="questionRow ml-0 mr-0">
                  <p className="questionSection">b.</p>{" "}
                  <p className="answerSection">
                    Under the image of the screen click “Take Screenshot” and
                    view the updated image that displays.
                  </p>
                </li>
                <img
                  alt=""
                  src={require("../../assets/images/helpCenter/commonRequestImg3.png")}
                />
              </ul>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
